import React from 'react'

import {withStyles} from 'material-ui'
import classNames from 'classnames'

const styles = theme => ({
    root: {
        textAlign: 'left',
        maxWidth: 600,
        margin: 10,
        '& h1': {
            ...theme.typography.display2,
            color: theme.palette.contrast,
        },
        '& h2': {
            ...theme.typography.heading,
            color: theme.palette.contrast,
        },
        '& p': {
            ...theme.typography.body1,
            color: theme.palette.contrast,
        },
    }
})

export const LandingHeroText = withStyles(styles) (
    ({classes, className='', children}) => (
        <div className={classNames(classes.root, className)}>
            {children}
        </div>
    )
)



// WEBPACK FOOTER //
// ./src/components/landinglib/LandingHeroText.jsx